var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "url(#paint0_linear_89_12739)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0349 26.8277C53.804 26.1172 53.1899 25.5992 52.4505 25.4918L40.5723 23.7658L35.2602 13.0023C34.9295 12.3323 34.247 11.9082 33.5 11.9082C32.7529 11.9082 32.0705 12.3323 31.7398 13.0024L26.4277 23.7659L14.5494 25.4919C13.8101 25.5994 13.1957 26.1173 12.9649 26.8279C12.734 27.5384 12.9266 28.3185 13.4616 28.84L22.0568 37.2181L20.0277 49.0483C19.9015 49.7847 20.2041 50.529 20.8086 50.9682C21.4131 51.4073 22.2144 51.4653 22.8758 51.1176L33.5 45.5321L44.1242 51.1176C44.7905 51.4678 45.5914 51.404 46.1914 50.9682C46.7958 50.529 47.0986 49.7848 46.9723 49.0483L44.9432 37.2181L53.5383 28.84C54.0733 28.3184 54.2658 27.5383 54.0349 26.8277Z",
    fill: "url(#paint1_linear_89_12739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_12739",
    x1: 33.5,
    y1: 67,
    x2: 33.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_12739",
    x1: 33.5,
    y1: 51.3431,
    x2: 33.5,
    y2: 11.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStart);
export default __webpack_public_path__ + "static/media/icStart.621d28c589cb3df35f4e2c17f24c73b9.svg";
export { ForwardRef as ReactComponent };